import React from 'react';
import styled from 'styled-components';
import useEditAdminUser from './hooks/useEditAdminUser';
import {
  EDIT_ADMIN_DESCRIPTION,
  EDIT_ADMIN_TITLE,
  SAVE_CHANGES,
  VIEW_ADMIN_TITLE,
} from '../../utils/constants';
import GeneralInformation from '../../components/EditAdminUser/GeneralInformation';
import Loading from '../../components/Loading';
import { AdminToastComponent } from '../../components/AdminUsers/AdminToast';
import { RolesSection } from '../../components/AddAdminUser';
import Form from '../../components/Form/Form';

const StyledLoading = styled(Loading)`
  height: 350px;
`;

const EditAdminUser = () => {
  const {
    isLoading,
    adminDetails,
    isFormInValid,
    adminDetails: {
      role: selectedRole = '',
      tenant,
      organisations: selectedOrganisations,
    },
    onEdit,
    onInputChange,
    onCancel,
    messageText,
    isEmailChanged,
    onCheckEmail,
    setIsEmailChanged,
    isViewOnlyRole,
  } = useEditAdminUser();

  return (
    <React.Fragment>
      <Form
        onCancel={onCancel}
        onSubmit={onEdit}
        submitButtonText={SAVE_CHANGES}
        headerTitle={isViewOnlyRole ? VIEW_ADMIN_TITLE : EDIT_ADMIN_TITLE}
        headerDescription={isViewOnlyRole ? '' : EDIT_ADMIN_DESCRIPTION}
        isDisabled={
          isFormInValid ||
          isViewOnlyRole ||
          messageText.length > 0 ||
          isEmailChanged
        }
      >
        {isLoading ? (
          <StyledLoading />
        ) : (
          <React.Fragment>
            <GeneralInformation
              admin={adminDetails}
              onChange={onInputChange}
              messageText={messageText}
              isEmailChanged={isEmailChanged}
              onCheckEmail={onCheckEmail}
              setIsEmailChanged={setIsEmailChanged}
            />
            <RolesSection
              selectedTenant={tenant}
              selectedOrganisations={selectedOrganisations}
              selectedRole={selectedRole}
              isEdit
              onChange={onInputChange as any}
              isView={!isViewOnlyRole}
            />
          </React.Fragment>
        )}
      </Form>
      <AdminToastComponent />
    </React.Fragment>
  );
};

export default EditAdminUser;
